import { FC } from "react";

export const CloseIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M9.69838 12.4999L2 20.1984L3.80162 22L11.5 14.3015L19.1984 22L21 20.1984L13.3016 12.4999L20.9998 4.80164L19.1982 3L11.5 10.6983L3.80182 3L2.00019 4.80164L9.69838 12.4999Z"
        fill="var(--swapper-text-color)"
      />
    </svg>
  );
};
